/* Kratus — home-product-carousel: botones prev/next (scroll por ancho de card)
   + barra de progreso (thumb = proporcion visible/total) ligada al scroll. Mismo
   esqueleto vanilla que section-home-favourite-looks.js / sport-collection-showcase.js
   (sin GSAP: rAF simple basta para un listener de scroll pasivo). El image-swap
   hover→segunda foto y el reveal del pill "Elegir opciones" son CSS puro (ver
   section-home-product-carousel.css), este archivo solo mueve el carrusel.
   Respeta prefers-reduced-motion desactivando el smooth-scroll de los botones. */

window.KratusMotion && window.KratusMotion.ready('home-product-carousel', function (root) {
  var sections = (root || document).querySelectorAll('[data-product-carousel]');
  if (!sections.length) return;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (!document.documentElement.dataset.productCarouselResizeBound) { // bind once (evita listeners apilados en shopify:section:load, patron kratus-motion.js header/hero-eclipse): recalcula sobre los tracks vivos en el DOM, nunca sobre una referencia capturada del track viejo
    document.documentElement.dataset.productCarouselResizeBound = '1';
    window.addEventListener('resize', function () {
      document.querySelectorAll('[data-product-carousel-track]').forEach(function (liveTrack) {
        liveTrack.dispatchEvent(new Event('scroll'));
      });
    }, { passive: true });
  }

  sections.forEach(function (section) {
    if (section.dataset.productCarouselBound) return; // guard: bind once (shopify:section:load puede re-disparar)
    section.dataset.productCarouselBound = '1';

    var track = section.querySelector('[data-product-carousel-track]');
    var prevBtn = section.querySelector('[data-product-carousel-prev]');
    var nextBtn = section.querySelector('[data-product-carousel-next]');
    if (!track) return;

    var ticking = false;

    function cardStep() {
      var card = track.querySelector('[data-product-carousel-card]');
      var gap = parseFloat(window.getComputedStyle(track).columnGap) || 0;
      var width = card ? card.getBoundingClientRect().width : track.clientWidth * 0.8;
      return width + gap;
    }

    function update() {
      ticking = false;
      var maxScroll = track.scrollWidth - track.clientWidth;

      if (prevBtn) prevBtn.disabled = track.scrollLeft <= 1;
      if (nextBtn) nextBtn.disabled = maxScroll <= 1 || track.scrollLeft >= maxScroll - 1;
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        track.scrollBy({ left: -cardStep(), behavior: reduceMotion ? 'auto' : 'smooth' });
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        track.scrollBy({ left: cardStep(), behavior: reduceMotion ? 'auto' : 'smooth' });
      });
    }

    track.addEventListener('scroll', onScroll, { passive: true });
    update();
  });
});
